<a [href]="pubD?.link" target="_blank">
  <img  *ngIf="pubD?.imageName" [src]="publiciteImageUri + pubD?.imageName" width="100%" alt="Pub D" [title]="pubD?.titre" />
  <!--<img  *ngIf="!pubD?.imageName" src="assets/img/logo/pub2.png" width="100%" alt="Pub D" title="Pub D" />-->
</a>
